import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
export const EmptyRange = () => {
    const { t } = useTranslation();
    return (_jsxs("div", { className: "content content--no-pull-requests-page", children: [_jsx("span", { className: "content__picture", children: "\u00A0" }), _jsx("h2", { className: "content__title", children: t('noPullRequest') }), _jsx("p", { className: "content__text", children: t('addMoreRepositories') })] }));
};
